import { render, staticRenderFns } from "./FluxFondosClassic.vue?vue&type=template&id=2961473c"
import script from "./FluxFondosClassic.vue?vue&type=script&lang=js"
export * from "./FluxFondosClassic.vue?vue&type=script&lang=js"
import style0 from "./FluxFondosClassic.vue?vue&type=style&index=0&id=2961473c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports